import { CodedError } from '../CodedError';
import { errorCodeTypes } from './errorCodeTypes';

export class TenantNotFoundError extends CodedError {
  static get errorName() {
    return errorCodeTypes.tenantNotFoundError.code;
  }

  constructor(message = errorCodeTypes.tenantNotFoundError.message) {
    super(message);
    this.code = errorCodeTypes.tenantNotFoundError.code;
    this.message = `${message} ${errorCodeTypes.tenantNotFoundError.code}`;
    this.name = errorCodeTypes.tenantNotFoundError.name;
  }
}
